import { createContext } from 'react';
import { jsx } from 'react/jsx-runtime';

var ApplicationContext = /*#__PURE__*/createContext(null);
function ApplicationProvider(_ref) {
  var owner = _ref.owner,
    children = _ref.children;
  return /*#__PURE__*/jsx(ApplicationContext.Provider, {
    value: owner,
    children: children
  });
}

export { ApplicationContext, ApplicationProvider };
//# sourceMappingURL=application-context.jsx.map
